import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import { Breadcrumb } from 'react-breadcrumbs'

import { Breadcrumbs } from 'Components/Breadcrumbs'
import { LayoutDashboard } from 'Components/Layout/Dashboard'
import { PageTitle } from 'Components/PageTitle'
import { SettingsTile } from 'Components/Settings/SettingsTile'
import { SettingsWrapper } from 'Components/Settings/SettingsWrapper'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import SettingsIcon from 'Assets/Images/icons/settings'
import { authorization } from 'Module/Auth/Auth'
import { PATHS } from 'Config/Routing/paths'
import { ModalCustom } from '../../Components/Modal/ModalCustom'

const linkToSuperset = 'http://54.157.47.48:8088/'

const SettingsBreadcrumbs = () => (
  <div>
    <Breadcrumbs icon={<SettingsIcon style={{ width: 20 }} />} />
    <Breadcrumb
      data={{
        title: 'Settings',
        pathname: `${PATHS.main.dashboard}${PATHS.dashboard.settings}`,
      }}
    />
  </div>
)

const Settings = () => {
  const [isModalShow, setModalShow] = useState(false)
  return (
    <HideWhenBlocked>
      <SettingsWrapper>
        <LayoutDashboard>
          <SettingsBreadcrumbs />
          <PageTitle>Settings</PageTitle>
          <div>
            {authorization.isAdmin() && (
              <Row>
                <Col xs={12}>
                  <SettingsTile
                    label="Signup Identification Documents"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.documentation
                    }`}
                  />
                  <SettingsTile
                    label="Invoice Export"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.invoiceExport
                    }`}
                  />
                  <SettingsTile
                    label="Tags management"
                    linkLabel="View/Edit"
                    path={`${PATHS.main.dashboard}${PATHS.dashboard.settings}${
                      PATHS.settings.tagsManagement
                    }`}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col xs={12}>
                {authorization.isAdmin() && (
                  <React.Fragment>
                    <SettingsTile
                      label="Legal Documents"
                      linkLabel="View/Edit"
                      path={`${PATHS.main.dashboard}${
                        PATHS.dashboard.settings
                      }${PATHS.settings.legalDocumentation}`}
                    />
                    <SettingsTile
                      label="NPS score"
                      linkLabel="View"
                      path={`${PATHS.main.dashboard}${
                        PATHS.dashboard.settings
                      }${PATHS.settings.npsScore}`}
                    />
                  </React.Fragment>
                )}
                {authorization.isCityManager() && (
                  <React.Fragment>
                    <SettingsTile
                      label="Superset"
                      linkLabel="View"
                      onClick={() => setModalShow(true)}
                    />
                    <ModalCustom
                      handleCancel={() => setModalShow(false)}
                      handleConfirm={() => {
                        window.open(linkToSuperset, '_blank')
                      }}
                      modalShow={isModalShow}
                      title="Use this 'Username' and 'Password'"
                      text=" "
                      children={
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                          }}
                        >
                          <div>Username: Oppizi</div>
                          <div>Password: oppizi</div>
                        </div>
                      }
                      cancelText="Cancel"
                      confirmText="Go to Superset"
                    />
                  </React.Fragment>
                )}
              </Col>
            </Row>
          </div>
        </LayoutDashboard>
      </SettingsWrapper>
    </HideWhenBlocked>
  )
}

export default Settings



// WEBPACK FOOTER //
// ./src/Containers/Settings/index.js